import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, X } from "lucide-react";
import { generateSticker } from "@/lib/api";
import { resolveImageUrl } from "@/components/ImageUpload";

// Generates a cute AI sticker (non-realistic) from a piece of text and returns its stored URL.
export default function StickerButton({ text, theme, context, value, onChange, testid, label = "Sticker con IA" }) {
  const [loading, setLoading] = useState(false);

  const make = async () => {
    const t = (text || "").trim();
    if (!t) { toast.error("Escribe primero el texto de esta sección"); return; }
    try {
      setLoading(true);
      const res = await generateSticker({ text: t, theme, ...(context || {}) });
      onChange(res.url);
      toast.success("¡Sticker listo!");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo crear el sticker");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      {value && (
        <div className="relative">
          <img src={resolveImageUrl(value)} alt="sticker" className="h-24 w-auto max-w-[160px] object-contain" data-testid={`${testid}-preview`} />
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-white shadow border border-warmgold/30 grid place-items-center text-inksoft hover:text-red-600"
            data-testid={`${testid}-remove`}
            aria-label="Quitar sticker"
          >
            <X size={10} />
          </button>
        </div>
      )}
      <button
        type="button"
        onClick={make}
        disabled={loading}
        className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-[11px] uppercase tracking-widest font-medium bg-warmgold/10 text-warmgold border border-warmgold/40 hover:bg-warmgold/20 transition-colors disabled:opacity-50"
        data-testid={testid}
      >
        {loading ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />}
        {loading ? "Creando sticker..." : value ? "Otro sticker" : label}
      </button>
    </div>
  );
}
